import { Component, Vue } from 'vue-property-decorator'
import { login } from '@/api'
import { UserModule } from '@/store/modules/user'
import { PermissionModule } from '@/store/modules/permission'
import router from '@/router'
@Component({ name: 'LoginPage' })
export default class LoginPage extends Vue {
  private username = '';
  private password = '';
  private jumpMap = [
    { role: '普通助教', to: '/student/list' },
    { role: '质检专员', to: '/student/list' },
    { role: '运营实习生', to: '/student/list' },
    { role: '运营实习生班长', to: '/student/list' },
    { role: 'supervisor', to: '/student/list' },
    { role: 'admin', to: '/employeeRole/employee_role' }
  ]

  private async onLogin () {
    if (this.username === '') { this.$notify.error({ title: '效验失败', message: '请输入您的用户名，如果信息遗忘请联系系统管理员。' }) }
    if (this.password === '') { this.$notify.error({ title: '效验失败', message: '请输入您的密码，如果信息遗忘请联系系统管理员。' }); return }
    const { error }: any = await login({ userName: this.username, password: this.password })
    if (error && error.returnCode !== 0) return
    this.$store.state.user.isLogin = true
    this.islogin()
  }

  private onUserEnter () {
    const pwdElem: any = this.$refs.password
    pwdElem.focus()
  }

  private jumpToPage () {
    const roles = UserModule.roles
    for (const item of this.jumpMap) {
      const { role, to } = item
      if (roles.indexOf(role) !== -1) {
        this.$set(this.$store.state.tagsView, 'visitedViews', [])
        this.$router.push({ path: to })
        // window.location.reload() // 清空tag标签缓存
        return
      } else {
        this.$set(this.$store.state.tagsView, 'visitedViews', [])
        this.$router.push({ path: '/home' })
        // window.location.reload()
      }
    }
  }

  private async islogin () {
    await UserModule.GetUserInfo()
    const roles = UserModule.roles
    PermissionModule.GenerateRoutes(roles)
    router.addRoutes(PermissionModule.dynamicRoutes)
    this.$message({ type: 'success', message: '登录成功' })
    await this.jumpToPage()
    await UserModule.GetMessageIsRead()
  }
}
